/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import './ProgramCard.scss';

const ProgramCard = ({
  id,
  startTime,
  endTime,
  speakerNames,
  tileRole,
  talk,
  color,
  onCardClick,
  selectedTalk
}) => {
  const history = useHistory();
  const cardRef = useRef(null);
  const talkExist = Object.entries(talk).length > 0;

  const onTalkClick = talkId => {
    if (id && history.location.pathname === '/program') {
      onCardClick(talkId);
    }
    if (id) {
      history.push(`/program/${talkId}`);
    }
  };

  useEffect(() => {
    if (
      history.location.pathname === '/program' &&
      selectedTalk &&
      selectedTalk === id &&
      cardRef.current
    ) {
      window.scrollTo(0, cardRef.current.offsetTop - 10);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={cardRef} id="program-card">
      <div
        className={`card ${Object.entries(talk).length === 0 || !id ? 'not-clickable' : ''} ${
          tileRole === 'CLOSED' ? 'closed' : ''
        }`}
        onClick={talkExist ? () => onTalkClick(id) : undefined}>
        <div className={`card-time ${color}`}>
          <span>{startTime}</span>
          <span>-</span>
          <span>{endTime}</span>
        </div>
        <div className="card-content">
          {talkExist ? (
            <div>
              <p className="program-card-top-row">{talk.title || tileRole}</p>
              <p className="program-card-speakers">
                <span className="speakers">
                  {speakerNames.length > 0 ? speakerNames.join(', ') : ''}
                </span>
                {talk.youtube ? (
                  <a href={talk.youtube} id="video-link" rel="noopener noreferrer" target="_blank">
                    <i className="fab fa-youtube-square fa-2x video" id="video-link" />
                  </a>
                ) : null}
              </p>
            </div>
          ) : (
            <div>
              <p className="program-card-top-row">
                <span className="is-full-desktop">{tileRole}</span>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ProgramCard.defaultProps = {
  id: '',
  onCardClick: () => {},
  selectedTalk: ''
};

ProgramCard.propTypes = {
  color: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
  id: PropTypes.string,
  onCardClick: PropTypes.func,
  selectedTalk: PropTypes.string,
  speakerNames: PropTypes.arrayOf(PropTypes.any).isRequired,
  startTime: PropTypes.string.isRequired,
  talk: PropTypes.objectOf(PropTypes.any).isRequired,
  tileRole: PropTypes.string.isRequired
};

export default ProgramCard;
